// * Check our database entry to see if we need to convert it into a format that dateFnsTz can read.
//   If none of the cases above were found, then it means that the date was likely formatted in a readable way to begin with,
//   and the original time zone is returned.

const getDateFnsTimeZone = (timeZone: string) => {
  switch (timeZone) {
    case "Pacific Time (US & Canada)":
      return "America/Los_Angeles";
    case "Central Time (US & Canada)":
      return "America/Chicago";
    case "Mountain Time (US & Canada)":
      return "America/Denver";
    case "Eastern Time (US & Canada)":
      return "America/New_York";
    case "Alaska":
      return "America/Anchorage";
    case "Hawaii":
      return "Pacific/Honolulu";
    default:
      return timeZone;
  }
};

export default getDateFnsTimeZone;
